export enum EncounterType {
    All = 'All',
    InPatient = 'InPatient',
    OutPatient = 'OutPatient',
    Emergency = 'Emergency',
    None = 'None',
}
